<div class="notePageContainer">

  <div *ngIf="!isLoading && note" class="p-grid p-justify-center marginzero">
    <div class="p-col-12">
      <p class="blueColor">{{ 'note_page_category' | translate }} {{categoryName}}</p>
    </div>

    <div class="p-col-12 p-md-5">
      <div class="imageContainer">
        <img *ngIf="note.preview" src="{{previewUrl}}/s_{{note.preview}}" alt="utwór" (click)="handleShowFullScreenImage()" />
        <!-- <img src="assets/note_mock.jpg" (click)="handleShowFullScreenImage()" /> -->
        <!-- <lib-ngx-image-zoom
          *ngIf="note.preview"
          thumbImage="http://preview.nuty.lukasz-waga.info/{{note.preview}}"
          fullImage="http://preview.nuty.lukasz-waga.info/{{note.preview}}"
        ></lib-ngx-image-zoom> -->
        <!-- [enableLens]="true"
        [circularLens]="true"
        [lensWidth]="300"
        [lensHeight]="300" -->
      </div>
    </div>

    <div class="p-col-12 p-md-7 notePanel">
      <div class="p-grid marginzero">
        <!-- <div class="p-col-3 p-sm-3 noteIcon">
          <img src="assets/orchestra_mock.png" alt="ikona" width="100%" height="100%" />
        </div> -->

        <div class="p-col-12">
          <div class="noteTitle">
            <h1 class="blueColor" style="margin-top: 0; margin-bottom: 10px;">{{ note.title }}</h1>
            <div *ngIf="note.rating" class="blueBackground rate">{{ note.rating }}</div>
          </div>
          <div class="blueColor levelRow">
            <div class="grayColor">{{ 'search_page_level' | translate }} </div>
            <app-note-level [levelFilter]="note.level" [readOnly]="true"></app-note-level>
          </div>
          <div class="grayColor" style="margin-bottom: 10px;">{{ 'note_page_composer' | translate }} {{ note.composer }}</div>
          <div class="grayColor" style="margin-bottom: 10px;">{{ 'note_page_author' | translate }} {{ note.music_author }}</div>
          <div class="grayColor">{{ 'note_page_arranger' | translate }} {{ note.arranger?.user_details?.name }} {{ note.arranger?.user_details?.surname }}</div>
        </div>
      </div>

      <div class="p-grid marginzero" style="align-items: flex-end;">
        <div class="p-col-8" style="padding-top:0; padding-bottom: 0;">
          <div style="display: flex; margin-bottom: 10px; align-items: center;">
            <div class="fb-share-button" [attr.data-href]="noteUrl" data-layout="button" data-size="large">
              <a target="_blank" [href]="fbButtonUrl" class="fb-xfbml-parse-ignore facebookShare">
                <fa-icon [icon]="faFacebookF"></fa-icon>
                <span>{{ 'share' | translate }}</span>
              </a>
            </div>
            <div style="margin-left: 10px;">
              <app-rate-note [noteId]="note.id" (reloadNote)="handleReloadNote()" ></app-rate-note>
            </div>
          </div>

          <!-- <audio *ngIf="playSrc" controls>
            <source [src]="playSrc | safeHtml" type="audio/mpeg">
          </audio> -->
          <app-audio-player [autoPlay]="false" *ngIf="playClicked" [src]="playSrc"></app-audio-player>
          <!-- <button *ngIf="!playClicked" class="playButton blueColor" (click)="playAudio()">
            <div class="playButtonIcon"><i class="pi pi-caret-right"></i></div>
            <div class="listen">{{ 'note_page_listen' | translate }}</div>
          </button> -->
        </div>

        <div class="p-col-4 smallCard">
          <div class="blueColor" style="margin-bottom: 10px;">{{ 'cart_table_header_price' | translate }}: <span style="font-weight: 500;">{{ note.price | currencyReduce | currency: selectedCurrency }}</span></div>
          <app-primary-button label="{{ 'track_to_cart' | translate }}" (action)="addToCart()"></app-primary-button>
        </div>
      </div>

      <div class="p-grid marginzero">
        <div class="p-col-12">
          {{ note.description }}
        </div>
      </div>

    </div>

    <div class="p-col-12">
      <h2 class="blueColor">{{ 'note_page_category_recommended' | translate }}</h2>

      <app-track-list [trackList]="recommendedNotes"></app-track-list>
    </div>

  </div>

  <div *ngIf="isLoading" class="p-col-12" style="text-align: center;"><p-progressSpinner></p-progressSpinner></div>

  <div *ngIf="!note && !isLoading">
    <p>{{ 'track_not_found' | translate }}</p>
  </div>

</div>

<p-dialog *ngIf="note && note.preview" header="{{ 'track_preview' | translate }}" [(visible)]="fullScreenImageMode" [style]="{width: '80vw'}" [baseZIndex]="10000">
  <img src="{{previewUrl}}/{{note.preview}}" style="width: 100%;" />
  <!-- <img src="assets/note_mock.jpg" style="width: 100%;" /> -->
</p-dialog>
